"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaceOfferButton = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var media_urls_1 = require("../constants/media-urls");

var useMediaContext_1 = require("../context/useMediaContext");

var Button_1 = require("../components/Button");

var NFTDataContext_1 = require("../context/NFTDataContext");

var nft_hooks_1 = require("@zoralabs/nft-hooks");

var PlaceOfferButton = function PlaceOfferButton(_ref) {
  var allowOffer = _ref.allowOffer,
      className = _ref.className;

  var _a;

  var _react_1$useContext = react_1.useContext(NFTDataContext_1.NFTDataContext),
      nft = _react_1$useContext.nft;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getString = _useMediaContext_1$us.getString,
      getStyles = _useMediaContext_1$us.getStyles;

  if (!nft.data) {
    return jsx_runtime_1.jsx(react_1.Fragment, {}, void 0);
  } // Disable offer functionality if not a zora NFT or if offers are disabled


  if ((allowOffer === false || !("zoraNFT" in nft.data) || nft.data.zoraNFT === undefined) && nft.data.pricing.auctionType !== nft_hooks_1.AuctionType.RESERVE) {
    return jsx_runtime_1.jsx(react_1.Fragment, {}, void 0);
  }

  function getBidURLParts() {
    var data = nft.data;

    if (!data) {
      return;
    }

    if (data.pricing.auctionType !== nft_hooks_1.AuctionType.RESERVE && data.nft.contract.knownContract !== 'zora') {
      return;
    }

    return [media_urls_1.ZORA_SITE_URL_BASE, "collections", data.nft.contract.address, data.nft.tokenId, data.pricing.auctionType === nft_hooks_1.AuctionType.RESERVE ? "auction/bid" : "offer"];
  }

  var bidURL = (_a = getBidURLParts()) === null || _a === void 0 ? void 0 : _a.join("/");

  if (!bidURL) {
    return jsx_runtime_1.jsx(react_1.Fragment, {}, void 0);
  }

  return jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullPlaceOfferButton", className), {
    children: jsx_runtime_1.jsx(Button_1.Button, Object.assign({
      primary: true,
      href: bidURL
    }, {
      children: getString(nft.data.pricing.auctionType === nft_hooks_1.AuctionType.RESERVE ? "PLACE_BID" : "PLACE_OFFER")
    }), void 0)
  }), void 0);
};

exports.PlaceOfferButton = PlaceOfferButton;